import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import CampaignIcon from '@mui/icons-material/Campaign';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import Tooltip from '@mui/material/Tooltip';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import axios from 'axios';
import Swal from 'sweetalert2';
import CsatDialog from './Dialog/CsatDialog';
import { buildCsatSurveyUrl } from '../utils/functions/csat';

const ManualSpeedDial = () => {
 
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
 

  useEffect(() => {
    let active = true;
    setOpen(false);
    // The callback must finish saving before we check eligibility again.
    if (pathname === '/csat-progress') return undefined;

    const checkCSATAvailability = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/csat/`);
        if (active) setOpen(response.data.isAvailable === true);
      } catch (error) {
        console.error('Error checking CSAT availability:', error);
      }
    };

    checkCSATAvailability();
    return () => { active = false; };
  }, [pathname]);

  const handleConfirm = () => {
    try {
      window.location.href = buildCsatSurveyUrl();
      setOpen(false);
    } catch (error) {
      Swal.fire({ title: 'ไม่สามารถเปิดแบบประเมินได้', text: error.message, icon: 'error' });
    }
  };

  const handleCloseApi = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/csat/dismiss`,
        { isHiddenThisWeek: false },
      );
      setOpen(false);

      if (response.status === 200) {
        console.log('API called successfully:', response.data);
      } else {
        console.warn('Unexpected response:', response);
      }
    } catch (error) {
      console.error('Error calling API:', error);
    }
  };

  return (
    <Box sx={{ height: 320, transform: 'translateZ(0px)', flexGrow: 1 }}>
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 5,
          transform: 'scale(0.8)',
        }}
        icon={<QuestionMarkIcon sx={{ color: '#fff' }} />}
      >
        <SpeedDialAction
          sx={{
            transform: 'scale(1.2)',
          }}
          icon={<CampaignIcon />}
          tooltipTitle="Report Problem"
          onClick={() => alert('test')}
        />
        <SpeedDialAction
          sx={{
            transform: 'scale(1.2)',
          }}
          icon={<MenuBookIcon />}
          tooltipTitle="User Manual"
          href={`https://test-npayment.inet.co.th/BillPaymentUserManual.pdf`}
          target="_blank"
        />
      </SpeedDial>

      <Tooltip title="ประเมินความพึงพอใจ">
        <SpeedDial
          onClick={async () => {
            try {
              // เรียก API เพื่อตรวจสอบสถานะการประเมิน
              const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/csat/check`,
              );
              const { isAvailable } = response.data;

              if (isAvailable) {
                // หากประเมินได้ ให้ยิงไปยัง URL ปลายทาง
                window.location.href = buildCsatSurveyUrl();
              } else {
                // หากประเมินไม่ได้ แสดงข้อความแจ้งผู้ใช้
                Swal.fire({
                  title: 'ไม่สามารถประเมินได้',
                  text: 'คุณอาจประเมินในรอบครึ่งปีนี้แล้ว หรือระบบยังไม่เปิดให้ประเมิน',
                  icon: 'warning',
                  confirmButtonText: 'ตกลง',
                  willOpen: () => {
                    document.querySelector('.swal2-container').style.zIndex =
                      '2000'; // ปรับค่า z-index ที่ต้องการ
                  },
                });
              }
            } catch (error) {
              console.error('Error checking CSAT availability:', error);
              Swal.fire({ title: 'ไม่สามารถเปิดแบบประเมินได้', text: error.message, icon: 'error' });
            }
          }}
          ariaLabel="SpeedDial basic example"
          sx={{
            position: 'absolute',
            bottom: 10,
            left: 60,
            transform: 'scale(0.8)',
          }}
          icon={<VolunteerActivismIcon sx={{ color: '#fff' }} />}
        />
      </Tooltip>
      <CsatDialog
        setOpen={setOpen}
        open={open}
        handleConfirm={handleConfirm}
        handleCloseApi={handleCloseApi}
      />

      {/* <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="lg">
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              right: 1,
              top: 0,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <iframe
            src={dialogUrl}
            width="100%"
            height="800px"
            style={{ border: 'none' }}
          />
        </DialogContent>
        <DialogActions
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            borderTop: '1px solid #ccc',
            backgroundColor: '#fff',
            padding: '20px',
          }}
        >
          <div
            style={{
              flexGrow: 1,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="contained"
              autoFocus
              onClick={handleCloseDialog}
              sx={{
                color: '#fff',
                borderRadius: 15,
                backgroundColor: 'grey',
              }}
            >
              Close
            </Button>
          </div>
        </DialogActions>
      </Dialog> */}
    </Box>
  );
};

export default ManualSpeedDial;
